<template>
  <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
          <span role="img" aria-label="Bar Chart">📊</span>&nbsp;&nbsp;
          <span class="has-text-weight-semibold">Balance Sheet</span>
        </router-link>

        <a
          :class="{ 'is-active': expand }"
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          @click="expand = !expand"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div :class="{ 'is-active': expand }" class="navbar-menu">
        <div class="navbar-start" @click="expand = false">
          <slot />
        </div>
        <div class="navbar-end">
          <a class="navbar-item" @click="logOut">
            Log Out
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('auth');

export default {
  data() {
    return {
      expand: false,
    };
  },

  methods: {
    ...mapActions(['logOut']),
  },
};
</script>
